import {
    listSelectLabel,
    getSecurityGroupList
} from "@/requests/securityCenter";
export default {
    namespaced: true,
    state: {
        groupList: [], // 管理组
        sucGroupList: [], // 搜索安全组
        softType: [], // 品牌
        allSecurityGroup: [] // 所有安全组
    },
    mutations: {
        setListInfo(state, listInfo) {
            state.groupList = listInfo.groupList;
            state.sucGroupList = listInfo.secGroupList;
            state.softType = listInfo.softType;
        },
        setSecurityInfo(state, securityInfo) {
            state.allSecurityGroup = securityInfo;
        }
    },
    actions: {
        async actionSetListInfo({ commit }) {
            let res = await listSelectLabel();
            if (res.code == 200) {
                commit("setListInfo", res.data);
            }
        },
        async actionSetSecurityInfo({ commit }) {
            let res = await getSecurityGroupList();
            if (res.code == 200) {
                commit("setSecurityInfo", res.data);
            }
        }
    }
};

